
<template>
  <div class="div" style="background-color: white">
  <Layout>
    <b-container class="body mt-4">
<!--      <a :href="`${$backendHost}/pdf/ishpdf.pdf`" target="_blank"><h5 class="text-center">{{$t('message.This_portal')}}</h5></a>-->
      <b-row>
        <b-col
            md="6"
            lg="4"
            cols="12"
            sm="12"
            offset="4"
        >
          <b-card class="mt-5 carddy">
            <b-card-header style="background-color: white">
<!--              <h4 style="text-align: center">{{$t('message.For_candidates')}}</h4>-->
<!--              <h4 style="text-align: center">{{$t('message.VacancyForeign')}}</h4>-->
            </b-card-header>
            <img class="w-100"
                src="@/assets/images/mno-image/1.1.png">
            <br>
<!--        <FormModal-->
<!--            class="d-flex justify-content-center mt-5" />-->
              <FModalForm
                      class="d-flex justify-content-center mt-5" />

          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
  </div>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";
import { projectData } from "./data-projects";
// import ModalForm from "./vacancy/ModalForm";
import FModalForm from "./vacancy/FModalForm";
// import FormModal from "./online-test/FormModal";
// import AdminModal from "./admin-panel/AdminModal";


export default {
  page: {
    title: "ProjectList",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // AdminModal,
    // FormModal,
    // ModalForm,
    FModalForm,
    Layout,

  },
  data() {
    return {
      projectData: projectData,
      title: "Projects List",
      details:[
        {
        image:"https://thumbs.dreamstime.com/b/employee-looking-search-job-icon-design-vector-graphics-various-use-187071462.jpg"
        },
      ],

    };
  },
}
</script>

<style scoped>
img{
  width: 300px;
  height: 250px;
  margin-left: 20px;
  margin-top: 40px;
}
.div {
  min-height: 120vh;
  background-image: url("../../../assets/images/default-image/987.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
}
.carddy{
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.60);
  height: 520px;
  margin-right: 30px
}
</style>



